import * as bootstrap from "bootstrap";

$(function () {

    const tooltipTriggerList = $('.btn-tooltip');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

})